import React, { useState } from "react";
import {
    Box,
    Heading,
    FormControl,
    FormLabel,
    Input,
    Select,
    Button,
    Text,
    useToast,
} from "@chakra-ui/react";
import { createSession } from "../api/createSession";

const CreateSessionPage = () => {
    const [date, setDate] = useState("");
    const [startHour, setStartHour] = useState(8);
    const [lengthHrs, setLengthHrs] = useState(1);
    const [location, setLocation] = useState("Fort Collins");
    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("date", date);
        console.log("startHour", startHour);
        console.log("lengthHrs", lengthHrs);
        console.log("location", location);
        console.log("name", name);
        // Validate form inputs
        if (!date || !startHour || !lengthHrs || !location || !name) {
            setError("Please fill in all fields");
            return;
        }

        // Check if the session is at least one week in advance
        const sessionDate = new Date(date);
        const currentDate = new Date();
        const oneWeekLater = new Date(
            currentDate.getTime() + 7 * 24 * 60 * 60 * 1000
        );
        if (sessionDate < oneWeekLater) {
            setError("Session must be at least one week in advance");
            return;
        }

        // Check if the session exceeds the 10 pm close time
        const endHour = parseInt(startHour) + parseInt(lengthHrs);
        if (endHour > 22) {
            setError("Session cannot exceed the 10 pm close time");
            return;
        }

        // Check if the session length exceeds 5 hours
        if (parseInt(lengthHrs) > 5) {
            setError("Session length cannot exceed 5 hours");
            return;
        }

        // Create the session
        const sessionRequest = {
            date,
            startHour: parseInt(startHour),
            lengthHrs: parseInt(lengthHrs),
            location: "fort-collins",
            company: "rekindle",
            name,
        };

        try {
            await createSession({ sessionRequest });
            toast({
                title: "Session created successfully",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Error",
                description: "Failed to create session",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <Box p={8}>
            <Heading as="h1" size="xl" mb={8}>
                Create Session
            </Heading>
            {error && (
                <Text color="red.500" mb={4}>
                    {error}
                </Text>
            )}
            <form onSubmit={handleSubmit}>
                <FormControl mb={4}>
                    <FormLabel>Date</FormLabel>
                    <Input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </FormControl>
                <FormControl mb={4}>
                    <FormLabel>Start Hour</FormLabel>
                    <Select
                        value={startHour}
                        onChange={(e) => setStartHour(e.target.value)}
                    >
                        {Array.from({ length: 14 }, (_, i) => (
                            <option key={i + 8} value={i + 8}>
                                {i + 8}:00
                            </option>
                        ))}
                    </Select>
                </FormControl>
                <FormControl mb={4}>
                    <FormLabel>Length (Hours)</FormLabel>
                    <Select
                        value={lengthHrs}
                        onChange={(e) => setLengthHrs(e.target.value)}
                    >
                        {Array.from({ length: 5 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {i + 1} hour{i !== 0 && "s"}
                            </option>
                        ))}
                    </Select>
                </FormControl>
                <FormControl mb={4}>
                    <FormLabel>Location</FormLabel>
                    <Input
                        type="text"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        isReadOnly
                    />
                </FormControl>
                <FormControl mb={4}>
                    <FormLabel>Name</FormLabel>
                    <Input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </FormControl>
                <Button type="submit" colorScheme="blue">
                    Create Session
                </Button>
            </form>
        </Box>
    );
};

export default CreateSessionPage;
